export default {
    state: {
        ssOrder: {
            shipment_type_id: null,
            recipient_type: null,
            payment_method_id: null,
            contact_number: null,
            is_save_address: false,
            country_iso2: null,
            city: null,
            city_id: null,
            building: null,
            apartment: null,
            recipient_first_name: null,
            recipient_last_name: null,
            company_name: null,
            district: null,
            district_id: null,
            subdistrict: null,
            sub_district_id: null,
            zipcode: null,
            address: null,
            address_2: null,
            passport_number: null,
            sms_notification: false,
            latitude: null,
            longitude: null,
        },
    },
    mutations: {
        ssSetCountryIso2(state, payload) {
            state.ssOrder.country_iso2 = payload
        },
        ssClearOrders(state) {
            Object.keys(state.ssOrder).forEach(key => {
                state.ssOrder[key] = null
            });
        },
        ssSetPaymentMethod(state, payload) {
            state.ssOrder.payment_method_id = payload
        },
        ssSetShipmentMethod(state, payload) {
            state.ssOrder.shipment_method_id = payload
        },
        ssSetOrderData(state, payload) {
            if (payload) {
                Object.keys(payload).forEach(key => {
                    state.ssOrder[key] = payload[key]
                });
            }
        },
        ssSetSaveNewAddress(state, payload) {
            state.ssOrder.is_save_address = payload
        },
        ssClearRecipientAddress(state) {
            const addressRecipientFields = [
                'contact_number',
                'city',
                'city_id',
                'building',
                'apartment',
                'entrance',
                'recipient_first_name',
                'recipient_last_name',
                'company_name',
                'district',
                'district_id',
                'subdistrict',
                'sub_district_id',
                'zipcode',
                'address',
                'address_2',
                'passport_number',
                'latitude',
                'longitude',
            ];
            addressRecipientFields.forEach((elem) => {
                state.ssOrder[elem] = null;
            })
        },
        ssSetRecipient(state, payload) {
            state.ssOrder = Object.assign(state.ssOrder, payload)
            if (payload.id) {
                delete state.ssOrder.id
            }
        },
    },
    actions: {
        ssSetCountryIso2 ({commit}, payload) {
            commit('ssSetCountryIso2', payload)
        },
        ssClearOrders ({commit}) {
            commit('ssClearOrders')
        },
        ssSetPaymentMethod ({commit}, payload) {
            commit('ssSetPaymentMethod', payload)
        },
        ssSetShipmentMethod ({commit}, payload) {
            commit('ssSetShipmentMethod', payload)
        },
        ssSetOrderData ({commit}, payload) {
            commit('ssSetOrderData', payload)
        },
        ssSetSaveNewAddress ({commit}, payload) {
            commit('ssSetSaveNewAddress', payload)
        },
        ssClearRecipientAddress ({commit}) {
            commit('ssClearRecipientAddress')
        },
        ssSetRecipient ({commit}, payload) {
            commit('ssSetRecipient', payload)
        }
    },
    getters: {
        ssGetCountryIso2: (state) => state.ssOrder.country_iso2,
        ssOrder: (state) => state.ssOrder,
    }
}
